import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Button,
  ButtonGroup,
  Backdrop,
  Card,
  CardContent,
  ListItemAvatar,
  Chip,
  ListItemText,
  ListItem,
  List,
  Avatar,
  Divider,
  Grid,
  IconButton,
  Select,
  Snackbar,
  TextField,
  Typography,
  CircularProgress,
  Modal,
} from "@mui/material";
import { useState, useContext } from "react";
import { ColorModeContext, useMode } from "../theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Topbar } from "../layouts/Topbar";
import AuthContext from "../auth/AuthProvider";
import Sidebarr from "../layouts/Sidebar";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Header from "../components/Header";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import { decode } from "base-64";
import Autocomplete from "@mui/material/Autocomplete";
import { api } from "../api";
import { fetchToken, fetchRole } from "../auth/Token";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useFormik, validateYupSchema } from "formik";
import * as Yup from "yup";
import {
  Stepper,
  Step,
  StepLabel,
  FormHelperText,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { ConnectingAirportsOutlined } from "@mui/icons-material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import SummarizeIcon from "@mui/icons-material/Summarize";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import KPeeLogo from "../LogoKPee1.png";

const PrintWithdrawals = () => {
  const location = useLocation();
  // const association_data = location.state && location.state.association_data;
  // const refund_accounts = location.state && location.state.refund_accounts;
  // const refund_data = location.state && location.state.refund_data;
  // const refund_accounts_total = location.state && location.state.refund_accounts_total;
  // const association_id = location.state && location.state.association_id;
  const { permissions } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [leaders, setLeaders] = useState([]);

  const stateData = JSON.parse(localStorage.getItem("printState") || "{}");

  const association_data = stateData.association_data;
  const refund_accounts = stateData.refund_accounts;
  const refund_data = stateData.refund_data;
  const refund_accounts_total = stateData.refund_accounts_total;
  const association_id = stateData.association_id;

  const fetchLeaders = () => {
    api
      .get(`/association/get/association/leaders/${association_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setLeaders(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
  }

  useEffect(() => {
    fetchLeaders();
  }, []);

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const printRef = React.useRef();

  const handlePrint = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

    const pageHeight = pdf.internal.pageSize.getHeight();
    const marginLeft = 10;
    const marginTop = 10;
    const marginRight = 10;
    const marginBottom = 10;
    let yOffset = 0;
    let pageNumber = 1;

    while (yOffset < pdfHeight) {
      if (pageNumber > 1) {
        pdf.addPage();
      }

      pdf.addImage(
        data,
        "PNG",
        marginLeft,
        marginTop - yOffset,
        pdfWidth - marginLeft - marginRight,
        pdfHeight - marginTop - marginBottom
      );

      // Add page label
      pdf.setFontSize(8); // Make the font size smaller
      pdf.text(
        `Page ${pageNumber}`,
        marginLeft - 9,
        pageHeight - marginBottom + 5
      );

      yOffset += pageHeight - marginTop - marginBottom;
      pageNumber++;
    }

    pdf.save("RefundsForm.pdf");
  };

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 5 }}>
          <Box sx={{ display: "flex", m: 1 }}>
            <Typography
              sx={{ ml: "5px" }}
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b>Print:</b>
              <IconButton onClick={handlePrint}>
                <SummarizeIcon size="small" />
              </IconButton>
            </Typography>
          </Box>
          <div ref={printRef} style={{ display: "block", marginBottom: 5 }}>
            <Box sx={{ m: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    sx={{ textAlign: "center", color: "grey", mb: 3 }}
                  >
                    <b>~ The Cooperative ~</b>
                  </Typography>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Avatar
                    src={KPeeLogo}
                    alt="KPee logo"
                    sx={{ width: 120, height: 120, m: "auto" }}
                  />
                </Grid>
                <Grid item xs={12} md={6} sx={{ display: "block", ml: 5 }}>
                  <Typography
                    sx={{ m: "3px" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Society: {association_data?.Society}</b>
                  </Typography>
                  <Divider variant="middle" />
                  <Typography
                    sx={{ m: "3px" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Cluster: {association_data?.Cluster}</b>
                  </Typography>
                  <Divider variant="middle" />
                  <Typography
                    sx={{ m: "3px" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Community: {association_data?.community_name}</b>
                  </Typography>
                  <Divider variant="middle" />
                  <Typography
                    sx={{ m: "3px" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Savings Group: {association_data?.Association_name}</b>
                  </Typography>
                  <Divider variant="middle" />
                  <Typography
                    sx={{ m: "3px" }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>
                      Total refunding amount:{" "}
                      {currencyFormat.format(refund_accounts_total)}
                    </b>
                  </Typography>
                  <Divider variant="middle" />
                </Grid>

                <Grid item xs={12} md={12}>
                  <Typography
                    variant="h4"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    sx={{ textAlign: "center" }}
                  >
                    <b>Refunds Form</b>
                  </Typography>
                </Grid>

                <Grid item xs={12} md={12}>
                  <Box sx={{ m: 1 }}>
                    <Table size="small" aria-label="a dense table">
                      <TableHead>
                        <TableRow
                          sx={{
                            // '&:last-child td, &:last-child th': { border: 0 },
                            // backgroundColor: '#f5f3f4',
                            py: 5,
                            // pageBreakInside: 'avoid', // Prevent page breaks inside rows
                            // breakInside: 'avoid', // For additional browser compatibility
                          }}
                        >
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Passbook</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Member FullName</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Accounts refunding</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Outstanding Loans</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Total Amount Refunding</b>
                            </Typography>{" "}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {refund_data.map((row, index) => {
                          // Filter accounts_details to include only those in refund_accounts
                          const filteredAccounts = row.accounts_details.filter(
                            (item) =>
                              refund_accounts.some(
                                (refundAccount) =>
                                  refundAccount.id === item.id &&
                                  refundAccount.association_member_id ===
                                    item.association_member_id
                              )
                          );

                          // Skip rendering this row if no accounts are being refunded
                          if (filteredAccounts.length === 0) {
                            return null;
                          }

                          return (
                            <TableRow
                              key={row.account_id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                                backgroundColor: "#f5f3f4",
                                py: 3,
                              }}
                            >
                              <TableCell align="left">
                                <Typography
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  variant="h6"
                                >
                                  <b>{row.passbook_number}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  variant="h6"
                                >
                                  <b>{row.member_name}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  variant="h6"
                                >
                                  <b>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      {filteredAccounts.map((item) => (
                                        <div
                                          key={item.id}
                                          style={{ margin: 3 }}
                                        >
                                          {item.account_name}:{" "}
                                          {currencyFormat.format(
                                            item.current_balance
                                          )}
                                        </div>
                                      ))}
                                    </Box>
                                  </b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  variant="h6"
                                >
                                  <b>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      {row.loan_details.map((item) => (
                                        <div style={{ m: 3 }}>
                                          {item.account_name}:{" "}
                                          {currencyFormat.format(
                                            item.current_balance
                                          )}
                                        </div>
                                      ))}
                                    </Box>
                                  </b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  variant="h6"
                                >
                                  <b>
                                    {currencyFormat.format(row.original_amount)}
                                  </b>
                                </Typography>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </Box>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Typography
                    variant
                    textAlign="left"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="h4"
                  >
                    <b>Group Guarantee</b>
                  </Typography>
                  <Typography
                    variant
                    textAlign="left"
                    variant="h6"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>
                      {" "}
                      We, the undersigned group
                      leaders and members, hereby confirm that we guarantee the
                      refunding of the amounts specified in this form. Each
                      member is entitled to receive the corresponding refund
                      amount stated next to their name. By signing below, we
                      individually and collectively commit to ensuring that all
                      refunds are properly distributed as agreed.
                    </b>
                  </Typography>
                </Grid>

                {leaders.map((leader) => (
                  <Grid item xs={12} md={4}>
                    <Divider sx={{ m: 2, mt: 5 }} />
                    <Box>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>
                          {leader?.position} ({leader?.name})
                        </b>
                      </Typography>
                    </Box>
                  </Grid>
                ))}
                <Grid item xs={12} md={4}>
                  <Divider sx={{ m: 2, mt: 5 }} />
                  <Box>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Sign</b>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4} sx={{ mb: 20, mt: 5 }}>
                  <Divider />
                  <Box>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Sign</b>
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </div>
        </Box>
      </main>
    </div>
  );
};

export default PrintWithdrawals;
